import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { Article, Product } from 'src/typings';
import { AddArticleComponent } from '../add-article/add-article.component';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.scss']
})
export class ArticleListComponent implements OnDestroy {
  @Input() set product(payload: Product | undefined) {
    this._product = payload;
    if (payload && payload.articles) {
      this.articles.next(payload.articles);
    }
    if (payload && !payload.articles) {
      this.loadArticles(payload);
    }
  }

  get product() {
    return this._product;
  }

  private _product: Product | undefined;

  articles = new BehaviorSubject<Article[]>([]);

  columnsToDisplay = ['article', 'menu'];

  addSubscription: Subscription;

  removeSubscription: Subscription;

  constructor(private productService: ProductService, private dialog: MatDialog) {
    this.addSubscription = this.productService.addArticleGW.subscribe((data) => {
      const newArr = [...this.articles.value];
      newArr.push(data.article);
      this.articles.next(newArr);
    });
    this.removeSubscription = this.productService.removeArticleGW.subscribe((data) => {
      const newArr = [...this.articles.value];
      const index = newArr.findIndex((row) => row.id === data.article.id);
      newArr.splice(index, 1);
      this.articles.next(newArr);
    });
  }

  ngOnDestroy(): void {
    this.addSubscription.unsubscribe();
    this.removeSubscription.unsubscribe();
  }

  async loadArticles(payload: Product) {
    const res = await firstValueFrom(
      this.productService.searchAlternativeArticle({
        product_id: payload.id
      })
    );
    this.articles.next(res.data);
  }

  addArticle() {
    const dialogRef = this.dialog.open(AddArticleComponent);
    dialogRef.componentInstance.product = this.product;
    dialogRef.componentInstance.doneEvent.subscribe((newArticle) => {
      if (newArticle) dialogRef.close();
    });
  }

  async removeArticle(article: Article) {
    const confirm = window.confirm('Точно удалить?');
    if (!confirm) return;
    await this.productService.removeAlternativeArticle(article.id).toPromise();
    if (!this.product) return;
    this.loadArticles(this.product);
    return;
  }
}
